import localStorage from '@/services/localStorage.service'

export const set = property => (state, payload) => (state[property] = payload)
export const toggle = property => state => (state[property] = !state[property])

export const toggleLocalStorage = property => state => {
  localStorage.setItem(property, !state[property]);
  state[property] = !state[property];
}

export const setLocalStorage = (property) => (state, payload) => {
  (typeof payload === "object") ? localStorage.setObject(property, payload) : localStorage.setItem(property, payload);
  state[property] = payload;
}



// WEBPACK FOOTER //
// ./src/utils/vuex.js